import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./wrappedTopMovers.module.css";

function TopMoverPlaceholder() {
  return (
    <div className={styles.topMoverPillPlaceholder}>
      <Placeholder.Line />
    </div>
  );
}

const PLACEHOLDER_COUNT = 6;

export function WrappedTopMoversPlaceholder() {
  return (
    <div className={styles.topMoversBox}>
      <div className={styles.topMoversTitle}>Top Movers</div>
      <div className={styles.topMoversGrid}>
        {Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
          <TopMoverPlaceholder key={i} />
        ))}
      </div>
    </div>
  );
}
